import dayjs from "dayjs";

/**
 * Expands a date-range filter to the viewer's full local calendar day:
 * fromDate → local start of day, toDate → local end of day.
 *
 * A cleared date picker stores "" — and dayjs("").toISOString() throws
 * RangeError — so any value that doesn't parse to a real date comes back
 * undefined, letting callers simply omit that side of the filter.
 */
export const adjustDateRangeToLocalDay = (
  fromDate?: string,
  toDate?: string,
): { adjustedFromDate?: string; adjustedToDate?: string } => {
  const fromDay = fromDate ? dayjs(fromDate) : null;
  const toDay = toDate ? dayjs(toDate) : null;

  return {
    adjustedFromDate: fromDay?.isValid()
      ? fromDay.startOf("day").toISOString()
      : undefined,
    adjustedToDate: toDay?.isValid()
      ? toDay.endOf("day").toISOString()
      : undefined,
  };
};
